import ThemifyIconContainer from "../../Componant/Icons/ThemifyIcon";

const ThemifyIcon = () => {
  return (
    <div className="page-body">
      <ThemifyIconContainer />
    </div>
  );
};

export default ThemifyIcon;
